let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("23sVT")).then(() => parcelRequire('8Sn5a'));